<div class="support-ticket-page">
  <div class="page-actions">
    <div class="filter-bar">
      <div class="sidebar-search">
        <mat-form-field appearance="outline" class="search-field" style="width: 285px; margin-left: -3px;">
          <input
            #searchInput
            matInput
            [formControl]="searchControl"
            placeholder="Search by Ticket No"
            aria-label="Search by Ticket No"
            class="no-outline"
          />
          <button
            mat-stroke-button
            matSuffix
            type="button"
            (click)="searchInput.focus()"
            class="icon-search-button"
          >
            <mat-icon class="icon-search">search</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="status-field">
        <mat-label>Status</mat-label>
        <mat-select [(value)]="selectedStatus" (selectionChange)="onStatusChange()">
          <mat-option *ngFor="let status of statusOptions" [value]="status.value">
            {{ status.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="btns action-btns">
      <button type="button" class="add primary-btn" (click)="openCreateTicket()">
        <span class="material-icons-outlined">add</span>
        New
      </button>
    </div>
  </div>

  <div class="state-wrapper" *ngIf="loading && tickets.length === 0">
    <mat-card class="state-card">
      <mat-spinner [diameter]="36"></mat-spinner>
      <p>Loading support tickets...</p>
    </mat-card>
  </div>

  <div class="state-wrapper" *ngIf="hasError && !loading && tickets.length === 0">
    <app-error-state [message]="errorMessage"></app-error-state>
    <button mat-stroked-button type="button" class="secondary-btn" (click)="retry()">
      Retry
    </button>
  </div>

  <div class="state-wrapper" *ngIf="!loading && !hasError && tickets.length === 0">
    <app-empty-state [message]="emptyStateMessage"></app-empty-state>
  </div>

  <div *ngIf="tickets.length > 0" class="ticket-table-shell">
    <div class="table-overflow-box scrollbar" id="scrollcustom">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8 support-ticket-table desktop-table"
      >
        <ng-container matColumnDef="ticketNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Ticket No</th>
          <td mat-cell *matCellDef="let element">
            <span class="cell-width">{{ element.ticketNo }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let element">
            <span class="description-cell" [matTooltip]="element.title">{{ element.title || '-' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element">
            <span class="description-cell" [matTooltip]="element.description">{{ element.description }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            <span [class]="getStatusClass(element.status)">{{ element.status }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created On (UTC)</th>
          <td mat-cell *matCellDef="let element">
            <span class="cell-width">{{ (element.createdOn || element.createdAt) | date: 'dd/MM/yyyy - hh:mm a' : 'GMT' }} UTC</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="align-text">Action</th>
          <td mat-cell *matCellDef="let element" class="align-text">
            <button
              mat-icon-button
              type="button"
              aria-label="View support ticket"
              matTooltip="View"
              (click)="$event.stopPropagation(); openTicket(element)"
            >
              <mat-icon class="view-icon">visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="ticket-row"
        ></tr>
      </table>
    </div>

    <div class="mobile-ticket-list">
      <mat-card
        class="ticket-card"
        *ngFor="let ticket of tickets; trackBy: trackByTicket"
      >
        <div class="ticket-card-head">
          <div>
            <label>Ticket No</label>
            <h4>{{ ticket.ticketNo }}</h4>
          </div>
          <span [class]="getStatusClass(ticket.status)">{{ ticket.status }}</span>
        </div>

        <div class="ticket-card-body">
          <div class="ticket-card-row">
            <label>Title</label>
            <p>{{ ticket.title || '-' }}</p>
          </div>
          <div class="ticket-card-row">
            <label>Description</label>
            <p>{{ ticket.description }}</p>
          </div>
          <div class="ticket-card-row two-col">
            <div>
              <label>Expected Completion Date (UTC)</label>
              <p>{{ ticket.expectedCompletionDate ? (ticket.expectedCompletionDate | date: 'dd/MM/yyyy' : 'GMT') : '-' }}</p>
            </div>
            <div>
              <label>Created On (UTC)</label>
              <p>{{ (ticket.createdOn || ticket.createdAt) | date: 'dd/MM/yyyy - hh:mm a' : 'GMT' }} UTC</p>
            </div>
          </div>
        </div>

        <div class="ticket-card-footer">
          <button mat-stroked-button type="button" class="secondary-btn" (click)="$event.stopPropagation(); openTicket(ticket)">
            View
          </button>
        </div>
      </mat-card>
    </div>

    <div class="paginator-toolbar">
      <div class="page-toolbar-group">
        <span class="page-selector-label">Rows per page</span>
        <mat-form-field appearance="outline" class="page-size-field">
          <mat-select [value]="currentPageSize" (selectionChange)="onPageSizeSelect($event.value)">
            <mat-option *ngFor="let size of pageSizeOptions" [value]="size">
              {{ size }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="page-toolbar-group page-toolbar-center">
        <span class="page-selector-label">Page</span>
        <mat-form-field appearance="outline" class="page-selector-field">
          <mat-select [value]="currentPage" (selectionChange)="onPageSelect($event.value)">
            <mat-option *ngFor="let page of pageNumbers" [value]="page">
              {{ page }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="page-selector-total">of {{ totalPages }}</span>
      </div>

      <div class="page-toolbar-group page-navigation-group">
        <button type="button" class="page-nav-button" (click)="goToPreviousPage()" [disabled]="currentPage <= 1">
          Previous
        </button>
        <span class="page-range-label">
          {{ pageRangeStart }}-{{ pageRangeEnd }} of {{ totalRecords }}
        </span>
        <button type="button" class="page-nav-button" (click)="goToNextPage()" [disabled]="currentPage >= totalPages">
          Next
        </button>
      </div>
    </div>
  </div>
</div>